import React from 'react'
import styled from 'styled-components'
import { Text } from '@pancakeswap/uikit'
import Balance from 'components/Balance'

interface TopFarmPoolProps {
  title: string
  title1: string
  percentage: number
  index: number
  image: string
  visible: boolean
}

const Card = styled.div`
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(12px);
  border-radius: 16px;
  padding: 16px 20px;
  margin-bottom: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.3s ease;
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  }
`

const TokenImage = styled.img`
  width: 52px;
  height: 52px;
  margin-right: 16px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`

const Title = styled(Text)`
  font-size: 14px;
  color: #efcb5d;
  margin-bottom: 4px;
`

const Subtitle = styled(Text)`
  font-size: 16px;
  font-weight: bold;
  color: #5a9f98;
`

const AprTag = styled.div<{ apr: number }>`
  font-size: 14px;
  font-weight: bold;
  padding: 6px 10px;
  border-radius: 12px;
  color: white;
 
  white-space: nowrap;
`

const TopFarmPool: React.FC<TopFarmPoolProps> = ({
  title,
  title1,
  percentage,
  image,
  visible,
}) => {
  if (!visible) return null

  return (
    <Card>
      <TokenImage src={`/images/wallet/top/${image}.png`} alt="token" />
      <Content>
        <Title>{title}</Title>
        <Subtitle>{title1}</Subtitle>
      </Content>
      <AprTag apr={percentage}>
        <Balance fontSize="14px" value={percentage} decimals={2} unit="%" /> APR
      </AprTag>
    </Card>
  )
}

export default TopFarmPool
